import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Building2, Ticket, CreditCard, LogOut, ShieldCheck, MessageSquare } from "lucide-react";
import { useAdmin } from "@/lib/adminAuth";
import { toast } from "sonner";

const nav = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Overview" },
  { to: "/admin/agencies", icon: Building2, label: "Agencies" },
  { to: "/admin/feedback", icon: MessageSquare, label: "Feedback" },
  { to: "/admin/coupons", icon: Ticket, label: "Coupons" },
  { to: "/admin/payments", icon: CreditCard, label: "Payments" },
];

export default function AdminLayout() {
  const { admin, logout } = useAdmin();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    toast.success("Signed out");
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-slate-50 flex">
      <aside className="w-64 shrink-0 border-r border-slate-200 bg-slate-900 text-white p-6 flex flex-col grain-overlay" data-testid="admin-sidebar">
        <div className="mb-10 flex items-center gap-2">
          <img src="/logo-mark.png" alt="Foliosy" className="h-9 w-9 object-contain shrink-0 bg-white rounded-lg p-1" />
          <div className="min-w-0">
            <p className="font-bold tracking-tight text-sm">Foliosy HQ</p>
            <p className="text-xs text-slate-400 font-mono inline-flex items-center gap-1"><ShieldCheck className="w-3 h-3" /> super-admin</p>
          </div>
        </div>
        <nav className="flex flex-col gap-1">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                  isActive ? "bg-white text-slate-900" : "text-slate-300 hover:bg-white/10 hover:text-white"
                }`
              }
              data-testid={`admin-nav-${item.label.toLowerCase()}`}
            >
              <item.icon className="w-4 h-4" /> {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto">
          <p className="text-xs text-slate-500 font-mono truncate mb-2">{admin?.email}</p>
          <button
            onClick={onLogout}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-slate-300 hover:bg-red-500/20 hover:text-red-300"
            data-testid="admin-logout-button"
          >
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
